import React from 'react';
import './FeedbackAnalytics.css';

function getRatingColor(rating) {
  if (rating >= 8) return 'badge-positive';
  if (rating >= 5) return 'badge-pending';
  return 'badge-negative';
}

export default function FeedbackAnalytics({ analytics }) {
  if (!analytics) {
    return <div className="loading">Loading analytics...</div>;
  }

  const { total_responses, overall_average, averages_by_question, questions } = analytics;

  return (
    <div className="card feedback-analytics">
      <h3>Feedback Overview</h3>
      <div className="grid grid-4" style={{ marginBottom: '1rem' }}>
        <div className="analytics-stat">
          <div className="stat-value">{total_responses}</div>
          <div className="stat-label">Total Responses</div>
        </div>
        <div className="analytics-stat">
          <div className={`stat-value ${getRatingColor(overall_average)}-text`}>
            {overall_average > 0 ? overall_average.toFixed(1) : '—'}
          </div>
          <div className="stat-label">Overall Average</div>
        </div>
      </div>

      {total_responses > 0 && questions && (
        <div className="rating-bars">
          {questions.map((q) => {
            const avg = averages_by_question[q.key] || 0;
            const pct = (avg / 10) * 100;
            const colorClass = getRatingColor(avg);
            return (
              <div key={q.key} className="rating-bar-row">
                <span className="rating-bar-label">{q.label}</span>
                <div className="rating-bar-track">
                  <div
                    className={`rating-bar-fill ${colorClass}`}
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className={`rating-bar-value badge ${colorClass}`}>
                  {avg > 0 ? avg.toFixed(1) : '—'}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
